import login from './login';

export default {
  language: 'sv-SE',
  country: 'se',
  name: 'Svenska',
  embeddedLocale: login,
};
